import { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import * as CookieConsent from 'vanilla-cookieconsent';

/**
 * Fires a Mautic pageview on every route change in the SPA,
 * but ONLY if the user has granted marketing cookie consent.
 * Listens for consent changes so tracking starts/stops in real time.
 */
function useMauticTracking() {
  const location = useLocation();
  const [mauticAllowed, setMauticAllowed] = useState(() => {
    return CookieConsent.acceptedCategory('analytics') || CookieConsent.acceptedCategory('marketing');
  });

  // Listen for consent changes
  const handleConsentChange = useCallback(() => {
    setMauticAllowed(CookieConsent.acceptedCategory('analytics') || CookieConsent.acceptedCategory('marketing'));
  }, []);

  useEffect(() => {
    window.addEventListener('cookie-consent-changed', handleConsentChange);
    return () => {
      window.removeEventListener('cookie-consent-changed', handleConsentChange);
    };
  }, [handleConsentChange]);

  useEffect(() => {
    if (mauticAllowed && typeof window.mt === 'function') {
      window.mt('send', 'pageview', {
        page_title: document.title,
        page_url: window.location.origin + location.pathname + location.search
      });
    }
  }, [location, mauticAllowed]);
}

export default useMauticTracking;
